import {
  SET_CURRENT_PROJECT_ID,
  CLEAR_CURRENT_PROJECT_ID,
  LOGOUT_COMPLETE,
} from 'js/constants/actionTypes';

const initialState = {
  currentProjectId: null,
};

export const currentProjectReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CURRENT_PROJECT_ID:
      return setCurrentProjectId(state, action);

    case CLEAR_CURRENT_PROJECT_ID:
    case LOGOUT_COMPLETE:
      return clearCurrentProjectId(state, action);

    default:
      return state;
  }
};

function setCurrentProjectId(state, action) {
  return {
    ...state,
    currentProjectId: action.payload.projectId,
  };
}

function clearCurrentProjectId(state, action) {
  return {
    ...state,
    currentProjectId: null,
  };
}
